import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=616bc61b&scoped=true&"
import script from "./ceshi.vue?vue&type=script&lang=js&"
export * from "./ceshi.vue?vue&type=script&lang=js&"
import style0 from "./ceshi.vue?vue&type=style&index=0&id=616bc61b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bc61b",
  null
  
)

export default component.exports